import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router/index'
import store from './store'
import configs from './common/configs'
import translations from './common/translations.js'
import vuetify from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueCurrencyFilter from 'vue-currency-filter'
import VueI18n from 'vue-i18n'
import VueApexCharts from 'vue-apexcharts'
import * as Sentry from '@sentry/vue'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'animate.css/animate.min.css'
import InitError from './views/InitError.vue'

Vue.config.productionTip = false

Vue.use(Loading, configs.optionsLoader)
Vue.use(VueTheMask)
Vue.use(VueSweetalert2)
Vue.use(VueApexCharts)
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

Vue.use(VueI18n)
Vue.component('apexchart', VueApexCharts)

const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'es',
  messages: translations
})

if (['production', 'preprod', 'test'].includes(process.env.VUE_APP_BLUENV) && process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    app: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_BLUENV || 'unknown',
    integrations: [
      Sentry.browserTracingIntegration({
        router,
        tracePropagationTargets: ['localhost', /^\//]
      })
    ],
    attachProps: true,
    logErrors: true
  })
}

const url = process.env.VUE_APP_BLUENV !== 'development' ? `${process.env.VUE_APP_BASE_API}/api` : '/api'

Vue.config.errorHandler = async (err, vm, info) => {
  if (process.env.VUE_APP_BLUENV === 'development') {
    console.error('Vue error:', err, info)
  }
  Sentry.captureException(new Error(err))
  const errorId = Math.random().toString(36).substr(4).toUpperCase()
  await axios.post(`${url}/notify-error`, {
    errorId,
    error: err.stack,
    component: `${vm.$options.name || ''} ${vm.$vnode.tag} `,
    uri: `${window.document.documentURI}`
  })
}

if (process.env.VUE_APP_ROLLBACK === 'true') {
  window.location.replace(process.env.VUE_APP_ROLLBACK_URL)
} else {
  axios.get(`${url}/getSession`, { withCredentials: true })
    .then(response => {
      const { data } = response.data
      new Vue({
        async beforeCreate () {
          await this.$store.dispatch('setUser', {
            isLoggedIn: data.isLoggedIn || false,
            user: data.user || {}
          })
          if (this.$store?.user?.mustChangePassword) {
            this.$router.push('/recoverPass')
          }
        },
        router,
        store,
        vuetify,
        i18n,
        render: h => h(App)
      }).$mount('#app')
    })
    .catch(error => {
      console.error('Error cargando sesión', error)

      new Vue({
        vuetify,
        render: h => h(InitError)
      }).$mount('#app')
    })
}
